import { VStack } from '@direct-frontend/components';
import { Outlet } from '@direct-frontend/modules-router';
import { useMobileView } from '#shared/lib/platform';
import { Footer } from '#widgets/Footer';
import DashboardLayoutDesktop from './DashboardLayout@desktop';
import styles from './DashboardLayout@mobile.module.css';

const DashboardLayout = () => {
    const showMobileView = useMobileView();

    if (!showMobileView) {
        return <DashboardLayoutDesktop />;
    }

    return (
        <VStack className={styles.container}>
            <Outlet />
            <Footer />
        </VStack>
    );
};

export default DashboardLayout;
